__turbopack_context__.v({
  "className": "krub_fde1e43e-module__X4_PbG__className",
});
